import { DELETE_CARD_APPLY_START } from '../../types';

export const delete_card_apply = (payload) => ({
  type: DELETE_CARD_APPLY_START,
  payload,
});
